import { useAllPatientDocuments } from "features/documents/hooks/useAllPatientDocuments";
import useHealthlinkAvailableServices from "features/healthlink/hooks/useHealthlinkAvailableServices";
import { usePracticeDetails } from "features/practice/hooks/usePracticeDetails";
import { usePatientLaboratoryResults } from "features/results/hooks/usePatientLaboratoryResults";
import { usePatientRadiologyResults } from "features/results/hooks/usePatientRadiologyResults";
import { useLatestPsaResult } from "hooks/useLatestPsaResult";

import { buildGpDetails } from "../utils/buildReferralPayloads";

export const useReferralData = ({
  patientId,
  generalInformationForm,
  isProstateReferral,
}) => {
  const {
    data,
    isLoading: isLoadingHospitals,
    error: hospitalsError,
  } = useHealthlinkAvailableServices();

  const { data: laboratoryResultsData } = usePatientLaboratoryResults({
    orderBy: "ASC",
    patientId,
    limit: 10000,
  });

  const { data: radiologyResultsData } = usePatientRadiologyResults({
    orderBy: "ASC",
    patientId,
    limit: 10000,
  });

  const { data: practiceDetails } = usePracticeDetails();
  const { data: documents } = useAllPatientDocuments(patientId);

  const { data: latestPsaResult } = useLatestPsaResult(patientId, {
    enabled: isProstateReferral,
  });

  const { hospitals: healthlinkAvailableServices, facilities } = data || {
    hospitals: undefined,
    facilities: undefined,
  };

  const selectedHospital = healthlinkAvailableServices?.find(
    (hospital) =>
      hospital.hospitalId.toString() ===
      generalInformationForm.watch("hospital")
  );

  const selectedFacility = facilities?.find((facility) => {
    return (
      facility.hospitalId === selectedHospital?.hospitalId &&
      facility.messageTypeName === generalInformationForm.watch("referralType")
    );
  });

  const isSpecialist = selectedFacility?.wsBrowserActive === 1;

  return {
    healthlinkAvailableServices,
    laboratoryResults: laboratoryResultsData?.results,
    radiologyResults: radiologyResultsData?.results,
    practiceDetails,
    documents,
    latestPsaResult,
    isLoadingHospitals,
    hospitalsError,
    selectedHospital,
    selectedFacility,
    isSpecialist,
    gpDetails: buildGpDetails(practiceDetails),
  };
};
